import { motion } from 'framer-motion'
import { Chip } from '@/components/ui/Chip'
import { skillCategories } from '@/data/skills'

export function Skills() {

  return (
    <section id="skills" className="py-20">
      <div className="container-max section-padding">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="max-w-6xl mx-auto"
        >
          {/* Section header */}
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-text-light dark:text-text-dark mb-4">
              Skills & Expertise
            </h2>
            <p className="text-lg text-text-light/70 dark:text-text-dark/70 max-w-2xl mx-auto">
              A comprehensive overview of my technical skills and areas of expertise
            </p>
          </div>


          {/* Skills by category - Horizontal layout */}
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
            {skillCategories.map((category, categoryIndex) => {
              const visibleSkills = category.skills

              return (
                <motion.div
                  key={category.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.4 + categoryIndex * 0.1 }}
                  viewport={{ once: true }}
                  className="bg-bg-light/30 dark:bg-bg-dark/30 border border-border-light dark:border-border-dark rounded-xl p-6 hover:bg-bg-light/50 dark:hover:bg-bg-dark/50 transition-colors duration-300"
                >
                  <div className="mb-4">
                    <h3 className="text-lg font-semibold text-text-light dark:text-text-dark mb-2">
                      {category.name}
                    </h3>
                    <p className="text-sm text-text-light/60 dark:text-text-dark/60">
                      {category.description}
                    </p>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {visibleSkills.slice(0, 6).map((skill, skillIndex) => (
                      <motion.div
                        key={skill.id}
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ 
                          duration: 0.3, 
                          delay: 0.6 + categoryIndex * 0.1 + skillIndex * 0.05 
                        }}
                        viewport={{ once: true }}
                      >
                        <Chip
                          className="text-xs"
                        >
                          {skill.name}
                        </Chip>
                      </motion.div>
                    ))}
                    {visibleSkills.length > 6 && (
                      <Chip className="text-xs opacity-60">
                        +{visibleSkills.length - 6} more
                      </Chip>
                    )}
                  </div>
                </motion.div>
              )
            })}
          </div>

        </motion.div>
      </div>
    </section>
  )
}
